module.exports = __webpack_public_path__ + "img/img_404.021aad7c.png";